import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import mutations from './mutations'
import actions from './actions'

import bibliometric from './modules/bibliometric.js'
import study from './modules/study.js'
// import standard from './index_standard.js' 
Vue.use(Vuex)
const store = new Vuex.Store({
	modules:{
		bibliometric,
		study,
	},
  //定义状态
	state: {
		httpUrl:'https://www.tcmkb.cn', 
        changeflag:1,//导航选择flag
		/*----首页导航信息----*/ 
		personalScore:'',//个人积分
		institutionalScore:'',//机构积分
		institutionName:'',//机构名称
		userName:'',//用户名称
		personalEndDate:'',//个人到期日期
		institutionEndDate:'',//机构到期日期
	},
	getters,
	mutations,
	actions
})

export default store